<section class="accounting-intro-section">
  <div class="box">
    <div class="box__left">
      <h4 class="box__subheading color-blue">
        {{ 'ACCOUNTING_NEW.ACCOUNTING_INTRO.SUBHEADING' | translate }}
      </h4>

      <h1 class="box__heading color-gray box__heading">{{ 'ACCOUNTING_NEW.ACCOUNTING_INTRO.HEADING' | translate }} </h1>

      <div
        class="box__heading-detail box__heading--mw"
        [innerHtml]="'ACCOUNTING_NEW.ACCOUNTING_INTRO.DETAIL' | translate"
      >
      </div>

      <div class="box__btn">
        <a
          id="becomePartnerFormLink"
          href="https://form.flowaccount.com/request-become-partner"
          rel="noopener noreferrer"
          target="_blank"
          class="flowbtn app-btn box__btn--layout"
        >
          {{ 'ACCOUNTING_NEW.ACCOUNTING_INTRO.BTN_FREE' | translate }}
        </a>
      </div>
    </div>

    <div class="box__right">
      <picture>
        <source
          srcset="https://flowaccountcdn.com/new_landing/image/functions/accounting/function-accounting-v2.webp"
          type="image/webp"
        />

        <img
          src="https://flowaccountcdn.com/new_landing/image/functions/accounting/function-accounting-v2.png"
          width="100%"
          loading="eager"
          alt="{{ 'ACCOUNTING_NEW.ACCOUNTING_INTRO.SUBHEADING' | translate }}"
          class="box__image"
        />
      </picture>
    </div>
  </div>
</section>
